import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Overview from '../components/Overview';
import TradingControl from '../components/TradingControl';
import MarketView from '../components/MarketView';
import StrategyManager from '../components/StrategyManager';
import ExchangeConfig from '../components/ExchangeConfig';
import AccountSettings from '../components/AccountSettings';
import BotStatePage from './BotStatePage';

export default function DashboardPage() {
  return (
    <div className="min-h-screen bg-background flex">
      <Sidebar />
      <div className="flex-1 md:pl-64">
        <div className="p-4 md:p-6">
          <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/trading" element={<TradingControl />} />
            <Route path="/market" element={<MarketView />} />
            <Route path="/strategies" element={<StrategyManager />} />
            <Route path="/exchanges" element={<ExchangeConfig />} />
            <Route path="/botstate" element={<BotStatePage />} />
            <Route path="/settings" element={<AccountSettings />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
